"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Styling_1 = require("../../Styling");
var GlobalClassNames = {
    root: 'ms-GroupShowAll',
    link: 'ms-Link'
};
exports.getStyles = function (props) {
    var theme = props.theme;
    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                position: 'relative',
                padding: '10px 84px',
                cursor: 'pointer',
                selectors: (_a = {},
                    _a["." + classNames.link] = {
                        fontSize: Styling_1.FontSizes.small
                    },
                    _a)
            }
        ]
    };
    var _a;
};
//# sourceMappingURL=GroupShowAll.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/GroupedList/GroupShowAll.styles.js
// module id = 892
// module chunks = 0